import React from 'react';
import {connectWithCore} from 'framework/hocs';
import _ from 'lodash';
import {Dimmer, Loader, Grid, Breadcrumb} from 'semantic-ui-react';
import Left from 'go/components/layout/left';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import {ContentDispatch} from 'framework';
import DynamicSideNav from 'go/components/dynamic/layout/dynamicSideNav';
import {DynamicComponent} from 'go/components/dynamic/dynamicComponent';
import {DynamicValidateContinueButtonConnected as DynamicValidateContinueButton} from 'componentLibrary';
import {Link} from 'react-router-dom';
import {Alert} from 'componentLibrary';
import {connect} from 'react-redux';
import {CLEAR_ALL_MSG} from 'common/types';
import SaveForLater from 'componentLibrary/modules/SaveForLater';

export class TriPanelReview extends DynamicComponent {
  constructor(props) {
    super(props);
    this.state = {
      leftExpanded: true,
      visibleSections: [],
      current: 0,
      needsDataBasedTitles: false,
      fullValidationRun: false,
      showSavedAlert: false,
      savedAlertText: '',
    };
  }

  componentDidMount() {
    const {config} = this.props;
    if (config.dataBasedTitlesLoaders && !_.isEmpty(config.dataBasedTitlesLoaders)) {
      this.setState({needsDataBasedTitles: true});
    }
  }

  componentDidUpdate() {
    // TODO, strip out dataBasedTitles and dynamicComponent from TriPanelReview
    const {config, dynamicComponent} = this.props;
    const locationTop = this.props.currentLocation.match(/^contents\[(\d+)\]/);
    if (locationTop && parseInt(locationTop[1]) !== this.state.current) {
      window.scrollTo(0, 0);
      this.setState({
        current: parseInt(locationTop[1]),
        visibleSections: [],
      });
    }

    if (this.state.needsDataBasedTitles === true) {
      const dataBasedTitlesLoaders = config.dataBasedTitlesLoaders;
      const dataBasedTitlesMapping = config.dataBasedTitlesMapping;
      const dataBasedTitles = _.get(dynamicComponent, 'dataBasedTitles');
      _.forEach(dataBasedTitlesLoaders, (entry) => {
        if (
          _.get(dynamicComponent, entry.dataPath) &&
          _.get(dynamicComponent, entry.dataPath).loading == false
        ) {
          let newDBTitles = [];
          // We can add more cases here later if we need to extract
          //   other values for data-based titles:
          if (entry.name === 'extractFromArrayByKey')
            newDBTitles = extractFromArrayByKey(
              _.get(dynamicComponent, entry.dataPath),
              dataBasedTitlesMapping,
              entry.key
            );

          this.props.saveDataBasedTitles(_.uniq(dataBasedTitles.concat(newDBTitles)));
          this.setState({needsDataBasedTitles: false});
        }
      });
    }
  }

  setCurrentFieldList = (location) => {
    const {message, config, clearAllMsg, navToSpecificLocation} = this.props;

    if (!_.isEmpty(message)) {
      clearAllMsg();
    }
    const locationTop = location.match(/^contents\[(\d+)\]/);
    if (locationTop && parseInt(locationTop[1]) !== this.state.current) {
      window.scrollTo(0, 0);
      this.setState({
        current: parseInt(locationTop[1]),
        visibleSections: [],
      });
    }

    /* Relying on a location contents[index] from config for navigation
       causes conflicts at times when the index is the same, in cases like showHides or conditional rendering. 
       It may also require updating the sequence index, when adding a new nav item.
       To avoid duplicate index issues, we can make use of using the contents['#navLinkId'], which is preferable and more flexible.
       Note: The #navLinkId should match the navLinkId of the main body section it should navigate to.
             For subChild navigation, use: contents['#parentNavLinkId']['#childNavLinkId']
       ex:
       // main body section
       "navLinkId": "projectCompletionDeadline", 
       // navigation
       {
         "href": "#Project completion deadline",
         "text": "Project completion deadline",
         "location": "contents[2]" // before
         "location": "contents['#projectCompletionDeadline']" // after
       },
       {
         "name": "Project completion deadline",
         "link": "contents[2]" // before
         "link": "contents['#projectCompletionDeadline']" // after
       }
    */
    const locationString = location.match(/^contents\['#(\w+)'\]/);
    if (locationString) {
      const selectedIndex = _.findIndex(config.contents, {
        navLinkId: locationString[1],
      });
      if (selectedIndex !== this.state.current) {
        window.scrollTo(0, 0);
        this.setState({
          current: selectedIndex,
          visibleSections: [],
        });
      }
    }

    //  If we are navigating to a sub-location:
    const locationChild = location.match(/.contents\[\d+\]$/);
    if (locationChild) {
      this.setState({
        visibleSections: _.uniq([location, ...this.state.visibleSections]), // Ensure our new location is the first visible one
      });
    }
    navToSpecificLocation(location);
  };

  handleVisibilityChange = (location, isVisible) => {
    if (isVisible) {
      let new_array = _.uniq([...this.state.visibleSections, location]);
      this.setState({visibleSections: new_array});
    } else {
      let new_array = _.filter(this.state.visibleSections, (section) => {
        return section !== location;
      });
      this.setState({visibleSections: new_array});
    }
  };

  handleContextRef = (contextRef) => this.setState({contextRef});

  toggleLeft = () => {
    this.setState({leftExpanded: !this.state.leftExpanded});
  };

  componentWillUnmount() {
    if (!_.isEmpty(this.props.message)) {
      this.props.clearAllMsg();
    }
  }

  render() {
    let {
      currentLocation,
      loading,
      handleSubmit,
      dynamicComponent,
      config,
      taskContext,
      breadCrumbConfig,
      limitContentWidth,
      message,
    } = this.props;

    let taskEntityType = _.get(config, 'taskEntityType', 'grant');

    if (taskEntityType.includes('.')) {
      taskEntityType = _.get(taskContext, taskEntityType, 'grant');
    }

    const createTaskLink = (id) => (
      <React.Fragment>
        <Breadcrumb.Divider />
        <Breadcrumb.Section>
          <Link title={id} to={`/${taskEntityType}/${id}`}>
            {id}
          </Link>
        </Breadcrumb.Section>
      </React.Fragment>
    );

    if (!loading) {
      let data = _.get(dynamicComponent, 'data');

      if (
        !_.isEmpty(this.state.visibleSections) &&
        this.state.visibleSections[0] !== currentLocation
      ) {
        this.props.navToSpecificLocation(this.state.visibleSections[0]);
      }

      let headerSlot = null;
      if (config.headerSlot) {
        headerSlot = _.map(config.headerSlot.contents, (entry, index) => (
          <React.Fragment>
            <ContentDispatch key={index} config={entry} />
          </React.Fragment>
        ));
      }

      let lists = _.map(config.contents, (entry, index) => (
        <React.Fragment>
          <ContentDispatch
            config={entry}
            data={_.get(data, 'payload')}
            key={entry.title}
            dynamicComponent={dynamicComponent}
            navToSpecificLocation={this.setCurrentFieldList}
            handleVisibilityChange={this.handleVisibilityChange}
            spot={`contents[${index}]`}
            handleSubmit={handleSubmit}
          />
          {this.props.continueValidateButton === true && !entry.hideContinue && (
            <DynamicValidateContinueButton
              currentLocation={this.props.currentLocation}
              sections={config.contents}
              section={entry}
              validateContinueErrorMsg={this.props.validateContinueErrorMsg}
            />
          )}
        </React.Fragment>
      ));

      let reviewPanel = null;
      if (config.reviewPanel) {
        reviewPanel = (
          <ContentDispatch
            config={config.reviewPanel}
            data={data}
            dynamicComponent={dynamicComponent}
            handleSubmit={handleSubmit}
            setCurrentFieldList={this.setCurrentFieldList}
            taskContext={taskContext}
          />
        );
      }

      const onSaveUnsave = (saved) => {
        this.setState({showSavedAlert: true});
        if (saved) {
          this.setState({
            savedAlertText: 'You have successfully saved this page for later',
          });
        } else {
          this.setState({
            savedAlertText: 'You have successfully unsaved this page for later',
          });
        }
      };

      const breadCrumbParentPath = _.get(breadCrumbConfig, 'path', '/tasks/');
      const breadCrumbParentText = _.get(breadCrumbConfig, 'text', 'Tasks');
      const breadCrumbShow = _.get(breadCrumbConfig, 'show', true);
      return (
        <React.Fragment>
          {_.map(config.listeners, (listenerConfig, index) => (
            <ContentDispatch config={listenerConfig} key={index} />
          ))}
          <Grid>
            {/* Must wrap content in Grid column for sticky side nav to work */}
            <Grid.Column>
              <Left expanded={this.state.leftExpanded} toggle={this.toggleLeft}>
                <DynamicSideNav
                  title="reviewNav"
                  items={_.get(dynamicComponent, 'dataBasedTitles')}
                  location={currentLocation}
                  navToSpecificLocation={this.setCurrentFieldList}
                  {...config}
                  context={_.get(dynamicComponent, 'context')}
                />
              </Left>
              <Main
                leftOffset={this.state.leftExpanded}
                leftCollapsed={!this.state.leftExpanded}
                limitWidth={limitContentWidth}
              >
                {!_.isEmpty(message) && (
                  <Alert header={message} type="success" dismissable />
                )}
                {this.state.showSavedAlert && (
                  <Alert
                    header={this.state.savedAlertText}
                    type="success"
                    dismissable
                    onDismiss={() => this.setState({showSavedAlert: false})}
                  />
                )}
                {headerSlot}
                <Grid>
                  <Grid.Row>
                    <Grid.Column computer={12}>
                      {breadCrumbShow && taskContext && (
                        <Breadcrumb id="taskBreadcrumbs">
                          <Breadcrumb.Section>
                            <Link title={breadCrumbParentText} to={breadCrumbParentPath}>
                              {breadCrumbParentText}
                            </Link>
                          </Breadcrumb.Section>
                          {_.get(
                            taskContext,
                            _.get(config, 'taskIdPath', 'processVariables.grantId')
                          ) &&
                            createTaskLink(
                              _.get(
                                taskContext,
                                _.get(config, 'taskIdPath', 'processVariables.grantId')
                              )
                            )}
                          {_.get(taskContext, 'task.name') && (
                            <React.Fragment>
                              <Breadcrumb.Divider />
                              <Breadcrumb.Section active>
                                {_.get(taskContext, 'task.name')}
                              </Breadcrumb.Section>
                            </React.Fragment>
                          )}
                        </Breadcrumb>
                      )}
                    </Grid.Column>
                    <Grid.Column computer={4} className="text-align-right">
                      <SaveForLater
                        taskContext={taskContext}
                        onSaveUnsave={onSaveUnsave}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <div ref={this.handleContextRef}>{lists[this.state.current]}</div>
                {reviewPanel}
              </Main>
            </Grid.Column>
          </Grid>
        </React.Fragment>
      );
    } else {
      return (
        <Dimmer active inverted>
          <Loader inverted />
        </Dimmer>
      );
    }
  }
}

export const extractFromArrayByKey = (data, mapping, key) => {
  const values = _.map(data, (entry) => mapping[entry[key]]);
  return _.compact(_.uniq(values));
};

const mapStateToProps = (state) => ({
  message: state.messages.messages,
});

export const mapDispatchToProps = (dispatch) => {
  return {
    clearAllMsg: () => {
      dispatch({type: CLEAR_ALL_MSG});
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectWithCore(TriPanelReview));
